import { render, staticRenderFns } from "./PasteInput.vue?vue&type=template&id=0a689d4c&scoped=true&"
import script from "./PasteInput.vue?vue&type=script&lang=js&"
export * from "./PasteInput.vue?vue&type=script&lang=js&"
import style0 from "./PasteInput.vue?vue&type=style&index=0&id=0a689d4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a689d4c",
  null
  
)

export default component.exports